var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
/**
 * Kareo wrapped component of the Material-UI DialogTitle. The prop API has been limited to props defined in DialogTitleProps.
 *
 * Material-UI DialogTitle: [Docs](https://v4.mui.com/components/dialogs/), [API](https://v4.mui.com/api/dialog-title/)
 *
 * @storybook: [Dialog](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-dialog)
 */
var DialogTitle = React.forwardRef(function (props, ref) {
    return React.createElement(MuiDialogTitle, __assign({}, props, { ref: ref }));
});
DialogTitle.displayName = 'KareoDialogTitle';
export default DialogTitle;
